/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceUtilizationSummary {
    getFixupPrototypeFunction() { return ResourceUtilizationSummary.fixupPrototype; }

    static newInstance(model: Partial<ResourceUtilizationSummary>): ResourceUtilizationSummary {
        let obj = Object.assign(new ResourceUtilizationSummary(), model);
        ResourceUtilizationSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceUtilizationSummary>): ResourceUtilizationSummary {
        if (!model) return null;
        return ResourceUtilizationSummary.newInstance(<ResourceUtilizationSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceUtilizationSummary) {
        if (!obj) return;

        models.ResourceUtilizationSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceUtilizationSummary): boolean {
        Object.setPrototypeOf(obj, ResourceUtilizationSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.from_time === undefined) {
            this.from_time = 0;
        }
        if (this.utilization === undefined) {
            this.utilization = 0;
        }
    }

    /**
     * Utilization Start Hour Of Day (0-23)
     */
    from_time: number;

    day: models.DayOfWeek;

    /**
     * Utilization Value
     */
    utilization: number;

}
